import { apiClient } from './apiClient';

const getReserves = async (data) => {
  return await apiClient.get('/reserves', data);
};

export const reservesApi = {
  getReserves,
};
